export default function Footer({ children }: { children: React.ReactNode}) {
  return (
    <div className="card-footer">
      {children}
    </div>
  )
}